module.exports = __webpack_public_path__ + "img/dropsmart-logo.7071a90d.png";